import { CoreApi } from '@framework/utils/core-api';
import { API_ENDPOINTS } from '@framework/utils/endpoints';
class Categories extends CoreApi {
  constructor(_base_path: string) {
    super(_base_path);
  }
  all(params: any) {
    return this.http
      .get(`${this._base_path}`, { params })
      .then((res) => res.data);
  }

  findDetail(params: any) {
    const { page, limit, type, sortPrice, categoryId, locale, shopId} = params;
    return this.http
      .get(`${API_ENDPOINTS.CATEGORY_DETAIL}/${categoryId}/products`, {
        params: {
          page: page || 1,
          limit: limit || API_ENDPOINTS.DEFAULT_PRODUCTS_PER_PAGE,
          type,
          sortPrice,
          shopId,
          categoryId: categoryId || ''
        }
      })
      .then((res) => res.data);
  }

  fetchShopCategories(params: any) {
    const { shopId, locale} = params;
    return this.http
      .get(`${API_ENDPOINTS.SHOP_CATEGORIES}`, {
        params: {
          shopId: shopId
        }
      })
      .then((res) => res.data);
  }
}

export const CategoriesService = new Categories(API_ENDPOINTS.FETCH_CATEGORIES);
export const FetchAllCategoriesService = new Categories(API_ENDPOINTS.FETCH_ALL_CATEGORIES);
